import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  FILTER_HISTORY_STORAGE_QUERY_KEY,
  type FilterHistoryItem,
  getFilterHistory,
  setFilterHistory,
} from './utils';

const useAddFilterHistory = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (item: FilterHistoryItem) => {
      const prev = getFilterHistory();
      const filtered = prev.filter((x) => !(x.query === item.query && x.date === item.date));
      if (item.query === filtered[0]?.query) return;

      const updated = [item, ...filtered].slice(0, 5);
      setFilterHistory(updated);
      return updated;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: FILTER_HISTORY_STORAGE_QUERY_KEY,
      });
    },
  });

  return mutation;
};

export default useAddFilterHistory;
